export default function TestErrorBoundaryPage() {
    throw new Error('Test error boundary');

    return null;
}
